import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { subscribeShopify } from '@/service';
import { getPagesPrivacyPolicy } from '@/utils/common';

export default function M() {
    const { useLang, useState, useRouter, gtm } = useGlobal();
    const { t } = useLang('RV');
    const { locale, query } = useRouter();
    const [msg, setMsg] = useState('');
    const [check, setCheck] = useState(!['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale));
    const [input, setInput] = useState('');

    const handleCheck = () => {
        setCheck(!check);
        setMsg(check ? t('A_check_tip') : '');
    };

    const handleInputChange = (v: any) => {
        setInput(v.target.value);
        if (msg && check) {
            setMsg('');
        }
    };

    const handleFocus = () => {
        if (msg && check) {
            setMsg('');
        }
    };

    const handleSubmit = async () => {
        const emailRegex = /^[\w.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(input)) {
            return setMsg(t('A_input_error'));
        }
        if (!check) {
            return setMsg(t('A_check_tip'));
        }
        // 订阅SMS
        const dataSMS = {
            email: input.trim(),
            contactListId: locale === 'au' ? '1208097006' : '1225726711',
            fields:
                locale === 'au'
                    ? [
                          {
                              id: '10539',
                              type: 'single',
                              value: 1,
                              overwrite: true,
                          },
                      ]
                    : [],
        };
        try {
            const res = await subscribeShopify(dataSMS, locale, {
                sector_name: t('M_subtitle'),
                entry_position: 6,
            });
            if (res?.code === '0') {
                setMsg(t('A_input_success'));
                setTimeout(() => {
                    setMsg('');
                }, 3000);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: t('A_btn'),
                    status: 'success',
                    tag: 'Agree',
                });
            } else {
                setMsg(res?.message);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: t('A_btn'),
                    status: 'fail',
                    tag: 'Agree',
                });
            }
        } catch (e) {
            setMsg(e);
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('A_btn'),
                status: 'fail',
                tag: 'Agree',
            });
        }
    };

    return (
        <div id="RV-M" className={`RV-M RV-box ${css['RV-M']}`}>
            <div className="wrapper">
                <div className="img-box">
                    <span className="tag">New</span>
                    <EFPicture src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717081060054/12.png" alt={'EcoFlow Alternator Charger'} />
                </div>
                <div className="msg-box">
                    <div className="inner">
                        <p className="subtitle">{t('M_subtitle')}</p>
                        <p className="big-title">
                            {t.rich('M_title', {
                                n: (text: string) => <span className="no-wrap">{text}</span>,
                            })}
                        </p>
                        <p className="desc">{t('M_desc')}</p>
                        <div className="control">
                            <input
                                type="text"
                                placeholder={t('M_placeholder')}
                                className="input"
                                value={input}
                                onChange={handleInputChange}
                                onFocus={handleFocus}
                            />
                            <button className="btn" onClick={handleSubmit}>
                                {t('A_btn')}
                            </button>
                        </div>
                        {msg && <p className={`msg ${msg === t('A_input_success') ? 'success' : ''}`}>{msg}</p>}
                        <p className="terms">
                            <input id="term-check" type="checkbox" className="check" checked={check} onChange={handleCheck} />
                            <label htmlFor="#term-check" className="terms-text">
                                {t.rich('M_terms', {
                                    a1: (text: string) => (
                                        <a href={`https://account.ecoflow.com/agreement/en-au/TermsOfUse.html`} className="link">
                                            {text}
                                        </a>
                                    ),
                                    a2: (text: string) => (
                                        <a href={getPagesPrivacyPolicy(locale)} className="link">
                                            {text}
                                        </a>
                                    ),
                                })}
                            </label>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
